import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import { FaNotesMedical } from 'react-icons/fa'
import { FiCheck } from 'react-icons/fi'
import { colors } from '../components/Colors'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import imgCadastramento from '../img/neonatal-2.png'
import imgConfianca from '../img/empatia-b.jpg'
import imgBloco2 from '../img/C-indice-infeccao.png'
import imgBloco3 from '../img/a-tipo-cirugia-tratamento.jpg'
import imgAnestesia from '../img/anestesia.jpg'
import imgSalaInteligente from '../img/sala-inteligente-nova.jpg'
import imgOncologica from '../img/oncologica.png'
import imgVascular from '../img/vascular.png'
import imgPlastica from '../img/plastica.png'
import imgAssoalho from '../img/assoalho-pelvico.png'
import PageHeader from '../components/PageHeader'
import CentralAtendimento from '../components/CentralAtendimento'
import Layout from '../components/Layout'
import PageEye from '../components/PageEye'
import VejaTambem from '../components/VejaTambem'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  ul,
  ol {
    li {
      margin-bottom: 1.5em;
      @media ${device.mobileL} {
        text-align: left;
      }
    }
  }
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h2 {
      text-align: left;
    }
  }

  .inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    div {
      .gatsby-image-wrapper {
        float: left;
        margin: 0px 40px 0 0;
        @media ${device.mobileL} {
          margin: 0px 40px 40px 0;
        }
      }
      img {
        float: right;
        margin: 0px 0 0 40px;
        @media ${device.mobileL} {
          margin: 0px 40px 40px 0;
        }
      }
    }
    .gatsby-image-wrapper {
      margin: 30px -20px 0 20px;
      height: 100%;
      width: 47%;
      @media ${device.mobileL} {
        margin: 0;
        height: auto;
        width: 100%;
      }
    }
    img {
      margin: 30px -20px 0 20px;
      height: 100%;
      width: 47%;
      @media ${device.mobileL} {
        margin: 0;
        height: auto;
        width: 100%;
      }
    }
    h2 {
      color: #8e8fc7;
    }
    div {
      img {
        float: left;
        margin: 0px 40px 0 0;
        @media ${device.mobileL} {
          margin: 0px 40px 40px 0;
        }
      }
    }
  }

  :nth-of-type(2) {
    .offsetImgMid {
      margin-left: 0;
    }
    .inner {
      div {
        width: 47.6%;
        @media ${device.mobileL} {
          width: 100%;
          margin-bottom: 20px;
        }
      }
    }
    img {
      margin-right: 0;
      width: 49%;
    }
    .gatsby-image-wrapper {
      margin-right: 0;
      width: 49%;
    }
    .quadros {
      display: flex;
      flex-wrap: wrap;
      margin-top: 40px;
      .quadro {
        display: flex;
        justify-content: space-between;
        width: 48%;
        background: ${colors.verdeGradiente};
        margin-bottom: 40px;
        color: #ffffff;
        p {
          padding-left: 2em;
          @media ${device.mobileL} {
            padding-right: 2em;
          }
        }
        .gatsby-image-wrapper {
          min-height: 280px;
          margin-right: 0;
          @media ${device.mobileL} {
            margin-left: 80px;
            margin-bottom: 0;
            min-height: 160px;
          }
        }
        img {
          min-height: 280px;
          margin-right: 0;
          @media ${device.mobileL} {
            margin-left: 80px;
            margin-bottom: 0;
            min-height: 160px;
          }
        }
        h3 {
          color: #fff8d1;
          position: relative;
          margin: 0;
          font-size: 1em;
          padding: 2em;
          padding-left: 36px;
          padding-right: 0;
          :before {
            position: absolute;
            content: '';
            top: 24px;
            left: 36px;
            border: 1px solid #ffffff;
            width: 5%;
            opacity: 0.5;
            @media ${device.mobileL} {
              left: 36px;
            }
          }
          :after {
            position: absolute;
            content: '';
            bottom: 24px;
            left: 36px;
            border: 1px solid #ffffff;
            width: 5%;
            opacity: 0.5;
            @media ${device.mobileL} {
              left: 36px;
            }
          }
          @media ${device.mobileL} {
            padding: 2em 1.5em 2em 1.5em;
          }
        }
        @media ${device.mobileL} {
          width: 100%;
          display: block;
        }
      }
    }
  }
  :nth-of-type(3) {
    background: ${colors.lilasGradiente};
    p {
      color: #ffffff;
    }
    h2 {
      color: #fff8d1;
    }
    .inner {
      :nth-of-type(2) {
        padding-top: 2em;
      }
      div {
        .gatsby-image-wrapper {
          float: right;
          margin: 0px 0 0 40px;
          @media ${device.mobileL} {
            margin: 0px 40px 40px 0;
          }
        }
        img {
          float: right;
          margin: 0px 0 0 40px;
          @media ${device.mobileL} {
            margin: 0px 40px 40px 0;
          }
        }
      }
    }
  }
  :nth-of-type(6) {
    background: ${colors.verdeGradiente};
    color: #ffffff;
    h2 {
      color: #fff8d1;
    }
  }
  :nth-of-type(7) {
    h2 {
      color: ${colors.lilas};
    }
  }
  :nth-of-type(8) {
    background: ${colors.lilasGradiente};
    h2 {
      color: #fff8d1;
    }
    .lista {
      li {
        width: 100%;
      }
    }
  }

  .lista {
    h3 {
      margin-top: 1.5em;
    }
    ul {
      padding: 0;
      margin: 2em 0 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        display: block !important;
      }
      li {
        margin: 0 0 1em 0;
        padding: 0.8em 2em 0.8em 4em;
        list-style: none;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
        position: relative;
        min-height: 40px;
        box-sizing: border-box;
        width: 49%;
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          width: 100% !important;
        }
        p {
          margin: 0;
        }
        @media ${device.mobileL} {
          width: 100%;
          padding: 0.8em 1.5em 0.8em 3.5em;
          margin: 0 0 1em 0;
        }
        svg {
          position: absolute;
          left: 25px;
          top: 15px;
          font-size: 1.8em;
          color: ${colors.verde};
          @media ${device.mobileL} {
            left: 15px;
          }
          @media all and (-ms-high-contrast: none),
            (-ms-high-contrast: active) {
            top: 10px !important;
          }
        }
      }
    }
    ol {
      padding: 0;
      margin: 0 0 0 2em;
      display: flex;
      flex-wrap: wrap;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        display: block !important;
      }
      li {
        margin: 0 1em 1em 3px;
        padding: 1em;
        background: #ffffff;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
        position: relative;
        min-height: 40px;
        box-sizing: border-box;
        width: 100%;
        color: #fff8d1;
        font-size: 30px;
        p {
          color: ${colors.cinza};
          font-size: 0.7em;
          margin: 0;
        }
        @media ${device.mobileL} {
          width: 100%;
          padding: 1em;
          margin: 0 0 1em 0;
        }
        svg {
          position: absolute;
          left: 25px;
          top: 32px;
          font-size: 1.8em;
          color: ${colors.verde};
        }
      }
    }
  }
`
export const CentroCirurgicoMulherTemplate = ({
  title,
  content,
  image,
  slug,
  color,
  area = 'Centros e Serviços',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          height="108px"
          overflow="visible"
        />
        <GroupContent>
          <div className="inner lista center">
            <div>{parse(sessoes[0].texto)}</div>
            {sessoes[0].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[0].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Confiança"
                className="offsetImgMid"
              />
            ) : (
              <img
                src={sessoes[0].imagemDaSessao.sourceUrl}
                alt="Confiança"
                className="offsetImgMid"
              />
            )}
          </div>
          <div className="inner quadros center">
            <div className="quadro">
              <div>
                <h3>{parse(sessoes[1].tituloDaSessao)}</h3>
                {parse(sessoes[1].texto)}
              </div>
              {sessoes[1].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[1].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Assoalho Pelvico"
                />
              ) : (
                <img
                  src={sessoes[1].imagemDaSessao.sourceUrl}
                  alt="Assoalho Pelvico"
                />
              )}
            </div>
            <div className="quadro">
              <div>
                <h3>{parse(sessoes[2].tituloDaSessao)}</h3>
                {parse(sessoes[2].texto)}
              </div>
              {sessoes[2].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[2].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Oncologica"
                />
              ) : (
                <img
                  src={sessoes[2].imagemDaSessao.sourceUrl}
                  alt="Oncologica"
                />
              )}
            </div>
            <div className="quadro">
              <div>
                <h3>{parse(sessoes[3].tituloDaSessao)}</h3>
                {parse(sessoes[3].texto)}
              </div>
              {sessoes[3].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[3].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Plastica"
                />
              ) : (
                <img src={sessoes[3].imagemDaSessao.sourceUrl} alt="Plastica" />
              )}
            </div>
            <div className="quadro">
              <div>
                <h3>{parse(sessoes[4].tituloDaSessao)}</h3>
                {parse(sessoes[4].texto)}
              </div>
              {sessoes[4].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[4].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Vascular"
                />
              ) : (
                <img src={sessoes[4].imagemDaSessao.sourceUrl} alt="Vascular" />
              )}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner lista center">
            <div>
              <h2>{parse(sessoes[5].tituloDaSessao)}</h2>
              <ol>
                {sessoes[5].listaDeItens.map((item, index) => (
                  <li key={index}>{parse(item.item)}</li>
                ))}
              </ol>
            </div>
          </div>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[6].tituloDaSessao)}</h2>
              {sessoes[6].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[6].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Sala inteligente"
                  className="offsetImgMid"
                />
              ) : (
                <img
                  src={sessoes[6].imagemDaSessao.sourceUrl}
                  alt="Sala inteligente"
                  className="offsetImgMid"
                />
              )}
              {parse(sessoes[6].texto)}
            </div>
          </div>
        </GroupContent>
        <PageEye
          title={sessoes[7].tituloDaSessao}
          content={sessoes[7].texto}
          image={sessoes[7].imagemDaSessao.sourceUrl}
          color="laranjaReverso"
          height="294px"
          right="0"
          imgWidth="492px"
          titleWidth="470px"
        />
        <PageEye
          title={sessoes[8].tituloDaSessao}
          content={sessoes[8].texto}
          image={sessoes[8].imagemDaSessao.sourceUrl}
          color="vermelho"
          height="294px"
          right="50px"
          imgWidth="450px"
          titleWidth="530px"
          overflow
        />
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[9].tituloDaSessao)}</h2>
              {sessoes[9].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[9].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Anestesia"
                  className="offsetImgMid"
                />
              ) : (
                <img
                  src={sessoes[9].imagemDaSessao.sourceUrl}
                  alt="Anestesia"
                  className="offsetImgMid"
                />
              )}
              {parse(sessoes[9].texto)}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              {sessoes[10].imagemDaSessao.localFile ? (
                <Img
                  fluid={
                    sessoes[10].imagemDaSessao.localFile.childImageSharp.fluid
                  }
                  alt="Tipo de cirurgia"
                  className="offsetImgStart"
                />
              ) : (
                <img
                  src={sessoes[10].imagemDaSessao.sourceUrl}
                  alt="Tipo de cirurgia"
                  className="offsetImgStart"
                />
              )}
              <h2>{parse(sessoes[10].tituloDaSessao)}</h2>
              {parse(sessoes[10].texto)}
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner lista center">
            <div>
              <h2>{parse(sessoes[11].tituloDaSessao)}</h2>
              <ul>
                {sessoes[11].listaDeItens.map((item, index) => (
                  <li key={index}>
                    <FiCheck />
                    {parse(item.item)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner lista center">
            <div>
              <h2>{parse(sessoes[12].tituloDaSessao)}</h2>
              <h3>{parse(sessoes[13].tituloDaSessao)}</h3>
              <ul>
                {sessoes[13].listaDeItens.map((item, index) => (
                  <li key={index}>
                    <FaNotesMedical />
                    {parse(item.item)}
                  </li>
                ))}
              </ul>
              <h3>{parse(sessoes[14].tituloDaSessao)}</h3>
              <ul>
                {sessoes[14].listaDeItens.map((item, index) => (
                  <li key={index}>
                    <FaNotesMedical />
                    {parse(item.item)}
                  </li>
                ))}
              </ul>
              <h3>{parse(sessoes[15].tituloDaSessao)}</h3>
              <ul>
                {sessoes[15].listaDeItens.map((item, index) => (
                  <li key={index}>
                    <FaNotesMedical />
                    {parse(item.item)}
                  </li>
                ))}
              </ul>
              <h3>{parse(sessoes[16].tituloDaSessao)}</h3>
              <ul>
                {sessoes[16].listaDeItens.map((item, index) => (
                  <li key={index}>
                    <FaNotesMedical />
                    {parse(item.item)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </GroupContent>
        <CentralAtendimento />
      </Container>
    </>
  )
}

CentroCirurgicoMulherTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const CentroCirurgicoMulher = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <CentroCirurgicoMulherTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />

      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

CentroCirurgicoMulher.propTypes = {
  data: PropTypes.object.isRequired,
}

export default CentroCirurgicoMulher

export const CentroCirurgicoMulherQuery = graphql`
  query CentroCirurgicoMulherById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
